import { AnalyticsPage, AnalyticsTicket, AnalyticsUser } from "@/shared/model/analytics/entities";
import { Constants } from "@/shared/model/enums/analytics/constants";
import { PageTheme, PageType } from "@/shared/model/enums/analytics/page";
import { reactive, watch } from "vue";
import useIsBreakpoint from "../use-is-breakpoint";
import { TicketKind } from "@/shared/model/enums/analytics/ticket";

const { currentBreakpointName } = useIsBreakpoint();
//AnalyticsPage
export const analyticsPageObj = reactive<AnalyticsPage>({
    type: PageType.List,
    category: "",
    kind: Constants.NotApplied,
    gameCode: Constants.NoGame,
    gameCodeStrict: Constants.NoGame,
    theme: PageTheme.Light,
    responseDesignCategory: currentBreakpointName?.value,
    verticalCode: Constants.KurzoveSazky, //always default KurzoveSazky
    verticalCodeStrict: Constants.KurzoveSazky, //always default KurzoveSazky
    appliedFilters: Constants.NotApplied,
    favoriteSports: "",
    opportunityType: "",
    displayOdds: Constants.NotApplied,
    displayScore: Constants.NotApplied,
});

export const analyticsTicketObj = reactive<AnalyticsTicket>({
    id: Constants.NotApplied,
    totalOdd: Constants.NotApplied,
    totalDeposit: Constants.NotApplied,
    potentialWinnings: Constants.NotApplied,
    additionalWinnings: Constants.NoAdditionalWinnings,
    type: Constants.NotApplied,
    ticketKind: TicketKind.Default,
    bets: [],
});

export const analyticsUserObj = reactive<AnalyticsUser>({
    oddSettings: Constants.NotApplied,
    showMiniTicket: Constants.NotApplied,
});

watch(analyticsPageObj, (newVal) => {
    if (!newVal.kind) {
        newVal.kind = Constants.NotApplied;
    }
});
